import React from 'react';
import Box from '@mui/material/Box';
import {Container} from '@mui/system';
import ElindusLogo from '../assets/rebranding/Elindus_Logo_Wordmark_RGB_Red.png';


export default function Footer() {
  return (
    <>
      <Container maxWidth={false} sx={{flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end'}} disableGutters>
        <Box width="100%" display="flex" justifyContent="center" alignItems="center" py={3}>
          <a href="https://www.elindus.be" target="_blank" rel="noopener noreferrer">
            <img src={ElindusLogo} width='300px' alt="Elindus"/>
          </a>
        </Box>
      </Container>
    </>
  )
}